var path = 'public/app/features/datasources/partials/http_settings.html';
var html = "";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;